var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginLayout',[_c('div',{staticClass:"login-new-page-login-container"},[_c('img',{staticClass:"cn-logo",attrs:{"src":_vm.cnLogo,"alt":"thecn.com"}}),_c('div',{staticClass:"login-new-page-login"},[_c('CoverImage'),_c('FormLogin',[_c('h2',{staticClass:"institution-heading"},[_vm._v(_vm._s(_vm.heading))])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }